import React from 'react';
import { AdminLayout } from '../layout/AdminLayout';
import { PageHeader } from '../common/PageHeader';
import { ReferentsSettings } from './settings/ReferentsSettings';

export default function ReferentsPage() {
    return (
        <AdminLayout>
            <PageHeader title="Referenten" subtitle="Stammdaten der BGPR-Referenten für die Seminar-Zuordnung" />
            <div className="mt-6">
                <ReferentsSettings />
            </div>
        </AdminLayout>
    );
}
